import smoothscroll from 'smoothscroll-polyfill';
import detectSmoothScroll from '../utils/detect-smooth-scroll-support';

window.addEventListener('DOMContentLoaded', () => {
  const smoothScrollNotSupported = detectSmoothScroll();
  if (smoothScrollNotSupported) smoothscroll.polyfill();
});
